import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const AttentionChartsDataContext = createContext();

const AttentionChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.ATTENTION_RESULTS,
            url: 'governanceroom/dashboard/vitalstatistics/results/attention',
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  cesareanBirths: data?.indicators?.cesareanBirths ?? 0,
                  normalBirths:
                      data?.indicators?.normalBirths ?? 0,
                  pregnantWomen6OrMorePrenatalConsultations:
                      data?.indicators?.pregnantWomen6OrMorePrenatalConsultations ?? 0,
                  pregnantWomenEarlyPrenatalCapture:
                      data?.indicators?.pregnantWomenEarlyPrenatalCapture ?? 0,
                  weightLess25KgxMothersLessThan6PrenatalConsultations:
                      data?.indicators?.weightLess25KgxMothersLessThan6PrenatalConsultations ?? 0,
                  pregnantWomen6PrenatalConsultations1To12Weeks:
                      data?.indicators?.pregnantWomen6PrenatalConsultations1To12Weeks ?? 0,
              },
              typesOfBirthMothersAge: data?.typesOfBirthMothersAge ?? [],
              preNatalConsultations: data?.preNatalConsultations ?? []
          }
        : {
              indicators: {
                  cesareanBirths: 0,
                  normalBirths: 0,
                  pregnantWomen6OrMorePrenatalConsultations: 0,
                  pregnantWomenEarlyPrenatalCapture: 0,
                  weightLess25KgxMothersLessThan6PrenatalConsultations: 0,
                  pregnantWomen6PrenatalConsultations1To12Weeks: 0,
              },
              typesOfBirthMothersAge: [],
              preNatalConsultations: []
          };

    return (
        <AttentionChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </AttentionChartsDataContext.Provider>
    );
};

export default AttentionChartsDataProvider;
